/* eslint-disable react-hooks/exhaustive-deps */
import { isBefore } from "date-fns";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useWorker from "~hooks/useWorker";
import { useGetNegociacoesPrecoRegra } from "~pages/Simulators/hooks/useSimulatorsQuery";

const useNegociacaoPrecoRegra = ({ filters, skip, take, setLoading = () => { }, clienteId }) => {
  const [negociacoesPrecoRegraEnabled, setNegociacoesPrecoRegraEnabled] = useState(true);

  useEffect(() => {
    setNegociacoesPrecoRegraEnabled(true);
  }, []);

  const negociacoesRequest = useGetNegociacoesPrecoRegra(negociacoesPrecoRegraEnabled);

  const negociacoesQuery = (withOrdem = true) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let startDate = new Date(today);
    startDate.setHours(0, 0, 0, 0);

    if (filters && filters.periodo) {
      startDate.setDate(today.getDate() - {
        last30days: 30,
        last15days: 15,
        last7days: 7,
        last60days: 60,
        last90days: 90,
        last5days: 5,
        last3days: 3,
        today: 0,
      }[filters.periodo]);
    }

    let negociacoesQuery = db.negociacaoPrecoRegra;

    if (clienteId) {
      const id = Number(clienteId);
      if (!isNaN(id)) {
        negociacoesQuery = negociacoesQuery.where('clienteId').equals(id);
      }
    }

    if (filters) {
      if (withOrdem) {
        if (filters.ordem) {
          if (filters.ordem === "antigos") {
            negociacoesQuery = negociacoesQuery.orderBy('id').reverse();
          } else {
            negociacoesQuery = negociacoesQuery.orderBy('id');
          }
        }
      }

      if (filters.grupoProduto || filters.produto || filters.filial || filters.tipoSolicitacao || filters.statusSolicitacao || filters.periodo) {
        negociacoesQuery = negociacoesQuery.filter((negociacao) => {
          if (!negociacao || typeof negociacao !== "object") return false;
          return (filters.grupoProduto ? negociacao.grupoProduto === filters.grupoProduto : true) &&
            (filters.produto ? negociacao.produto === filters.produto : true) &&
            (filters.filial ? negociacao.filial === filters.filial : true) &&
            (filters.tipoSolicitacao ? negociacao.tipoSolicitacao === filters.tipoSolicitacao : true) &&
            (filters.statusSolicitacao ? negociacao.statusNegociacao === filters.statusSolicitacao : true) &&
            (filters.periodo ? isBefore(startDate, new Date(negociacao.createdAt)) : true);
        });
      }
    }

    return negociacoesQuery
  }

  const total = useLiveQuery(() => {
    return negociacoesQuery(false).count();
  }, [filters, negociacoesRequest?.data]);

  const [negociacoesAll, setNegociacoesAll] = useState([]);

  useEffect(() => {
    const fetchNegociacoes = async () => {
      const result = [];
      await negociacoesQuery().each((item) => result.push(item));
      setNegociacoesAll(result);
    };

    fetchNegociacoes();
  }, [filters, total, negociacoesRequest?.data]);

  const [negociacoes, setNegociacoes] = useState([]);

  useEffect(() => {
    const fetchNegociacoes = async () => {
      const result = [];
      if (take == 0) await negociacoesQuery().each((item) => result.push(item));
      else await negociacoesQuery().offset(skip).limit(take).each((item) => result.push(item));
      setNegociacoes((prev) => [...prev, result]);
    };

    fetchNegociacoes();
  }, [filters, skip]);

  const totalRenderizado = useMemo(() => {
    if (negociacoes) {
      if (typeof setLoading == "function") setLoading(false);
      return negociacoes.length;
    }
    return 0;
  }, [negociacoes]);

  const { save } = useWorker({
    table: "negociacaoPrecoRegra",
  });

  useEffect(() => {
    if (negociacoesRequest.data) {
      save(negociacoesRequest.data);
    }
  }, [negociacoesRequest.data])

  return { negociacoes, total, totalRenderizado, negociacoesAll };
}

export default useNegociacaoPrecoRegra;